'use client';

import type { ReactNode } from 'react';
import classnames from 'classnames';
import { DialogOverlay } from '../Dialog';
import { Panel } from '../Panel/Panel';
import styles from './Notification.module.scss';

interface NotificationProps {
  title: string;
  message?: string;
  children?: ReactNode;
  /** Extra classes on the notice's Panel. */
  className?: string;
}

/**
 * A blocking notice in the thick, glowing panel frame. Like `Modal`, it
 * takes keyboard focus while shown, keeps Tab inside it and hands focus back
 * when it goes. It has no close of its own: its children offer the way out.
 */
export function Notification({ title, message, children, className }: NotificationProps): JSX.Element {
  return (
    <DialogOverlay label={title} className={styles.overlay} dialogClassName={styles.dialog}>
      <Panel className={classnames(styles.notification, className)} frame="thick" glow>
        <h2 className={styles.title}>{title}</h2>
        {message && <p className={styles.message}>{message}</p>}
        {children}
      </Panel>
    </DialogOverlay>
  );
}
